import { useContext, useEffect, useState } from "react";
import AppContext from "../../utils/AppContext";
import { api, handleNetworkError } from "../../utils/api";

import OTPModal from "../../common/OTPModal/OTPModal";
import { Trans as T } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { ReactComponent as ErrorIcon } from "../../assets/icons_svg/error-lined.svg";
import './ChangeEmailPasswordModal.scss';

export default function ChangeEmailModal({ show, onHide }) {
  const [, dispatch] = useContext(AppContext);

  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState(null);
  const [validated, setValidated] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  useEffect(() => {
    if (show) {
      setEmail('');
      setErrors(null);
      setValidated(false);
    }
  }, [show]);

  const onSubmit = async e => {
    e?.preventDefault();
    setErrors(null);
    setValidated(false);
    
    try {
      const { data } = await api.post('/change-email/', { email });
      dispatch({ type: 'currentUser/set', payload: data });
      console.log('data:', data)
      dispatch({ type: 'globalToast/set', payload: { message: "Your email address has been updated" }});
      setShowOTP(false);
      onHide();
    }
    catch (e) {
      checkForVerification(e);
    }
  }

  const checkForVerification = e => {
    const code = e?.response?.data?.code;

    if (code === 'verification_required') {
      setShowOTP(true);
    }

    else {
      handleNetworkError({ e, setErrors, setValidated });
    }
  }

  return (
    <>
      <Modal className='__modal __change-email-password-modal' size='sm' show={show && !showOTP} onHide={onHide} centered>
        <Modal.Header closeButton><h2><T>Change Email</T></h2></Modal.Header>
        <Form noValidate validated={validated && !errors} onSubmit={onSubmit}>
          <Modal.Body>
            <div className="change-warning">
              <ErrorIcon />
              <div>
                <p><strong><T>You will use your new email to sign in</T></strong></p>
                <p><T>Verify your email is typed correctly so you can receive important communications</T></p>
              </div>
            </div>
            <Form.Group className="field-group">
              <Form.Label><T>New email address</T></Form.Label>
              <Form.Control type='email' autoComplete="off" value={email} onChange={e => setEmail(e.target.value)} isValid={validated && !errors?.email} isInvalid={errors?.email} />
              { errors?.email?.map(error => <Form.Control.Feedback type='invalid' key={error}>{ error } </Form.Control.Feedback>)}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type='button' className='cancel' onClick={onHide}><T>Close</T></Button>
            <Button className="confirm" type="submit" disabled={!email.trim()}><T>Confirm</T></Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <OTPModal show={showOTP} onHide={() => setShowOTP(false)} onConfirm={onSubmit} />
    </>
  );
}
